import React from 'react';
import { CSVLink } from 'react-csv';
import { IInitialState } from '../../../../../../../../redux/duck/legado/clientsApp/interface/reduxInterface';
import DownloadButton from '../../../../../../../../shared/components/buttons/DownloadButton';
import Csv from '../../../../../../../../shared/components/icons/Csv';

function ExportCsv(props: IInitialState) {
  const header = [
    { label: 'ID', key: 'id' },
    { label: 'Nome', key: 'companyName' },
    { label: 'Cpf/Cnpj', key: 'cpfCnpj' },
    { label: 'ID do Parceiro', key: 'partnerId' },
    { label: 'Tipo de Conta', key: 'accountType' },
    { label: 'ID do Parceiro', key: 'partnerId' },
    { label: 'Telefone', key: 'cel' },
    { label: 'E-mail', key: 'email' },
    { label: 'Logradouro', key: 'publicPlace' },
    { label: 'Número', key: 'number' },
    { label: 'Bairro', key: 'district' },
    { label: 'Complemento', key: 'complement' },
    { label: 'Cidade', key: 'city' },
    { label: 'Estado', key: 'country' },
    { label: 'CEP', key: 'cep' },
    { label: 'Situação da conta', key: 'status' },
    { label: 'Agência', key: 'agency' },
    { label: 'Conta', key: 'account' },
    { label: 'Digito', key: 'digit' },
    { label: 'Tarifa Mensal', key: 'monthlyFare' },
    { label: 'Tarifa de TED', key: 'tedFare' },
    { label: 'Tarifa de Boleto', key: 'boletoFare' },
    { label: 'Saldo', key: 'balance' },
  ];

  return (
    <CSVLink
      data={props.clientsList.clients}
      headers={header}
      filename="lista_de_clientes.csv">
      <DownloadButton>
        <Csv />
      </DownloadButton>
    </CSVLink>
  );
}

export default ExportCsv;
